import { $Elements, BrowserEvents, Classes, Elements } from '../global/constants';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Newsletter ----------

		if(typeof newsletter_params !== 'undefined') {

			$('form.newsletter-form').each(function() {

				const form = $(this);
				const input = form.find('input[type=email]');
				const button = form.find('button[type=submit]');
				const tooltip = form.find('.invalid-tooltip');

				form.on('submit', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					e.stopPropagation();

					input.removeClass('is-invalid');
					button.attr('disabled', true);
					Elements.LoadingBar.classList.add(Classes.loading);

					const formData = new FormData(form[0]);
					formData.append('action', newsletter_params.action);
					formData.append('nonce', newsletter_params.nonce);

					$.ajax({
						url: newsletter_params.url,
						type: 'POST',
						dataType: 'json',
						data: formData,
						processData: false,
						contentType: false,
					}).always((response) => {

						button.attr('disabled', false);
						Elements.LoadingBar.classList.remove(Classes.loading);

						if(response.success) {
							form.empty();
							form.append('<div class="success-message"><span>' + response.data.message + '</span></div>')
						}
						else {
							tooltip.text(response.data.error);
							input.addClass('is-invalid');
							console.error(response);
						}
					});

					return false;
				});
			});
		}
	});

}(jQuery));
